<div class="app-loader-wrapper">
  <div class="app-loader-overlay"></div>
  <xt-ui-kit-spinner class="app-loader-spinner" />
</div>
